<div class="btn btn-sm close_btn" (click)="goBack()" data-bs-dismiss="modal">X</div>
<!-- <div class="container-fluid py-4"> -->
<div class="card  bg-white border-0">
  <div class="card-header d-flex align-items-center justify-content-between w-100">
    <!-- Stepper -->
    <div class="stepper col-md-12 col-sm-12 d-flex align-items-center justify-content-between mt-2 py-3"
      *ngIf="view=='client'">
      <div *ngFor="let step of steps; let i=index" class="step" [class.active]="i <= currentStep" (click)="goToStep(i)">
        <div class="circle">
          <i *ngIf="i < currentStep || isStepCompleted(i)" class="bi bi-check-lg"></i>
          <span *ngIf="i >= currentStep && !isStepCompleted(i)">
            {{i + 1}}
          </span>
        </div>
        <div class="label">
          {{step}}
        </div>
      </div>
    </div>
  </div>
  <div class="card-body px-3" style="overflow: auto; height: 65vh;">
    <!-- STEP 1 -->
    <!-- <form #instForm="ngForm" *ngIf="currentStep===1"> -->
    <div *ngIf="currentStep==0">
      <div class="row g-3">
        <div class="col-md-6">
          <label>Institute Name <span class="required">*</span></label>
          <input class="form-control" required name="instituteName" [(ngModel)]="formData.institute.inst_name">
        </div>
        <div class="col-md-6">
          <label>Institute Type <span class="required">*</span></label>
          <!-- <input class="form-control" required name="board" [(ngModel)]="formData.institute.inst_type"> -->
          <select class="form-select" [(ngModel)]="formData.institute.inst_type">
            <option value="">Select</option>
            @for(it of dataService.institute_types; track $index;) {
            <option value="{{it.code}}">{{it.name}}</option>
            }
          </select>
        </div>
        <div class="col-md-6">
          <label>Reg./Affiliation</label>
          <input type="email" class="form-control" required name="reg_no" [(ngModel)]="formData.institute.reg_no">
        </div>
        <div class="col-md-6">
          <label>Phone No <span class="required">*</span></label>
          <input type="tel" class="form-control" required name="mobile" [(ngModel)]="formData.institute.phone_no"
            maxlength="10">
        </div>
        <!-- <div class="col-12">
          <label>Address</label>
          <textarea class="form-control" required name="address" [(ngModel)]="formData.institute.address"></textarea>
        </div>
        <div class="col-md-3">
          <label>City</label>
          <input class="form-control" name="city" required [(ngModel)]="formData.institute.city">
        </div>
        <div class="col-md-3">
          <label>State</label>
          <input class="form-control" name="state" required [(ngModel)]="formData.institute.state">
        </div>
        <div class="col-md-3">
          <label>Pincode</label>
          <input class="form-control" name="pincode" required maxlength="6" [(ngModel)]="formData.institute.pincode">
        </div> -->
        <div class="row g-3 mt-2">
          <div class="col-md-8">
            <label class="form-label">Address <span class="required">*</span></label>
            <textarea class="form-control addressBox" rows="5" [(ngModel)]="formData.institute.address"></textarea>
          </div>
          <div class="col-md-4">
            <label class="form-label">&nbsp;</label>
            <div class="mb-1">
              <!-- <label class="form-label">
                    State
                </label> -->
              <select class="form-select" [(ngModel)]="formData.institute.state"
                (change)="formData.institute.district = dataService.getDist(formData.institute.state)">
                <option>Select State</option>
                @for(st of dataService.cityDataDD; track $index) {
                <option>{{st.state}}</option>
                }
              </select>
            </div>
            <div class="mb-1">
              <!-- <label class="form-label">
                    City
                </label> -->
              <select class="form-select" [(ngModel)]="formData.institute.city">
                <option>Select City</option>
                @for(dist of formData.institute.district; track $index) {
                <option>{{dist}}</option>
                }
              </select>
            </div>
            <input type="text" class="form-control mb-1" [(ngModel)]="formData.institute.pincode" placeholder="Pincode"
              maxlength="8">
          </div>
        </div>
      </div>
    </div>
    <!-- </form> -->

    <!-- STEP 2 CONTACTS -->
    <div *ngIf="currentStep===1">
      <div class="mb-2 mt-0 text-danger"><b>Note</b>: You must assign at least one contact as 'ERP Admin' to ensure new login details are received.</div>
      <div *ngFor="let contact of formData.contacts; let i=index" class="card mb-3 border">
        <div class="card-header d-flex justify-content-between align-items-center">
          <strong class="ms-3"> Contact {{i+1}} - {{dataService.getDesiName(contact.person_desi)}}
          </strong>
          <button [disabled]="i == 0" class="btn btn-danger btn-sm"
            style="border-radius: 0 6px 0 0;" (click)="removeContact(i)"> X </button>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-4">
              <input class="form-control" placeholder="Contact Name" [(ngModel)]="contact.person_name" name="name{{i}}">
            </div>
            <div class="col-md-4">
              <select class="form-select" [(ngModel)]="contact.person_desi" name="designation{{i}}">
                <!-- [disabled]="['erp', 'chm', 'ppl', 'acc'].includes(contact.person_desi) && i<4" -->
                <option value="">Select Designation</option>
                @for(d of dataService.designations; track $index) {
                  <option value="{{d.code}}">{{d.name}}</option>
                }
              </select>
            </div>
            <div class="col-md-4">
              <!-- <input class="form-control" placeholder="Department" [(ngModel)]="contact.department"
                name="department{{i}}"> -->
              <select class="form-select" [(ngModel)]="contact.department" name="department{{i}}">
                <option value="">Select Department</option>
                @for(d of dataService.departments; track $index) {
                  <option value="{{d.code}}">{{d.name}}</option>
                }
              </select>
            </div>
            <div class="col-md-4">
              <input class="form-control" placeholder="Mobile" [(ngModel)]="contact.mobile_no1" name="mobile{{i}}"
                maxlength="10">
            </div>
            <div class="col-md-4">
              <input class="form-control" placeholder="Alternate Mobile" [(ngModel)]="contact.mobile_no2"
                name="altmobile{{i}}" maxlength="10">
            </div>
            <div class="col-md-4">
              <input type="email" class="form-control" placeholder="Email" [(ngModel)]="contact.email_id"
                name="email{{i}}">
            </div>
            <div class="col-12">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" [(ngModel)]="contact.is_primary"
                  [checked]="contact.is_primary" id="primary{{i}}" name="primary{{i}}" (change)="setPrimary(i)">
                <label class="form-check-label" for="primary{{i}}"> Primary Contact </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn-sm btn-success" (click)="addContact()"> Add Contact </button>
    </div>

    <!-- STEP 3 BILLING -->
    <div *ngIf="currentStep===2">
      <div class="row g-3">
        <div class="col-md-6">
          <input class="form-control" placeholder="Billing Name" [(ngModel)]="formData.billing.billing_name">
        </div>
        <div class="col-md-3">
          <input class="form-control" placeholder="GST Number" [(ngModel)]="formData.billing.gst_no">
        </div>
        <div class="col-md-3">
          <input class="form-control" placeholder="GST State Code" [(ngModel)]="formData.billing.gst_state_code">
        </div>
        <!-- <div class="col-12">
          <label>Address</label>
          <textarea class="form-control" required name="address" [(ngModel)]="formData.billing.address"></textarea>
        </div>
        <div class="col-md-3">
          <label>City</label>
          <input class="form-control" name="city" required [(ngModel)]="formData.billing.city">
        </div>
        <div class="col-md-3">
          <label>State</label>
          <input class="form-control" name="state" required [(ngModel)]="formData.billing.state">
        </div>
        <div class="col-md-3">
          <label>Pincode</label>
          <input class="form-control" name="pincode" required maxlength="6" [(ngModel)]="formData.billing.pincode">
        </div> -->
        <div class="row g-3 mt-2">
          <div class="col-md-8">
            <label class="form-label">Address</label>
            <textarea class="form-control addressBox" rows="5" [(ngModel)]="formData.billing.address"></textarea>
          </div>
          <div class="col-md-4">
            <label class="form-label">&nbsp;</label>
            <div class="mb-1">
              <!-- <label class="form-label">
                    State
                </label> -->
              <select class="form-select" [(ngModel)]="formData.billing.state"
                (change)="formData.billing.district = dataService.getDist(formData.billing.state)">
                <option>Select State</option>
                @for(st of dataService.cityDataDD; track $index) {
                <option>{{st.state}}</option>
                }
              </select>
            </div>
            <div class="mb-1">
              <!-- <label class="form-label">
                    City
                </label> -->
              <select class="form-select" [(ngModel)]="formData.billing.city">
                <option>Select City</option>
                @for(dist of formData.billing.district; track $index) {
                <option>{{dist}}</option>
                }
              </select>
            </div>
            <input type="tel" class="form-control mb-1" [(ngModel)]="formData.billing.pincode" placeholder="Pincode">
          </div>
        </div>

      </div>
    </div>

    <!-- STEP 4 -->
    <!-- <form #orgForm="ngForm" *ngIf="currentStep===0"> -->
    <div *ngIf="currentStep==3">
      <div class="checkbox-group">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="formData.organization.org_exists" />
          <span>Sister concern institute already under the same organization.</span>
        </label>
      </div>

      <p class="text-danger">
        NOTE: Your organization ID will be assigned by Macwill admin after payment confirmation.
      </p>

      <div class="row g-3">
        <div class="col-md-6">
          <label>Code
          </label>
          <input type="url" class="form-control" name="code" [(ngModel)]="formData.organization.org_code" disabled>
        </div>
        <div class="col-md-6">
          <label>Organization Name <span class="required">*</span>
          </label>
          <input class="form-control" name="organizationName" required
            [(ngModel)]="formData.organization.org_name">
        </div>
        <!-- <div class="col-12">
          <label>Address</label>
          <textarea class="form-control" name="address" required [(ngModel)]="formData.organization.address"></textarea>
        </div>
        <div class="col-md-3">
          <label>City</label>
          <input class="form-control" name="city" required [(ngModel)]="formData.organization.city">
        </div>
        <div class="col-md-3">
          <label>State</label>
          <input class="form-control" name="state" required [(ngModel)]="formData.organization.state">
        </div>
        <div class="col-md-3">
          <label>Pincode</label>
          <input class="form-control" name="pincode" required maxlength="6" [(ngModel)]="formData.organization.pincode">
        </div> -->
        <div class="row g-3 mt-2" *ngIf="!formData.organization.org_exists">
          <div class="col-md-8">
            <label class="form-label">Address</label>
            <textarea class="form-control addressBox" rows="5" [(ngModel)]="formData.organization.org_address"></textarea>
          </div>
          <div class="col-md-4">
            <label class="form-label">&nbsp;</label>
            <div class="mb-1">
              <!-- <label class="form-label">
                    State
                </label> -->
              <select class="form-select" [(ngModel)]="formData.organization.org_state"
                (change)="formData.organization.district = dataService.getDist(formData.organization.org_state)">
                <option>Select State</option>
                @for(st of dataService.cityDataDD; track $index) {
                <option>{{st.state}}</option>
                }
              </select>
            </div>
            <div class="mb-1">
              <!-- <label class="form-label">
                    City
                </label> -->
              <select class="form-select" [(ngModel)]="formData.organization.org_city">
                <option>Select City</option>
                @for(dist of formData.organization.district; track $index) {
                <option>{{dist}}</option>
                }
              </select>
            </div>
            <input type="tel" class="form-control mb-1" [(ngModel)]="formData.organization.org_pincode"
              placeholder="Pincode">
          </div>
        </div>
      </div>
    </div>
    <!-- </form> -->

    <!-- STEP 5 PACKAGE -->
    <div *ngIf="currentStep===4">
      <div class="row g-3">
        <div class="col-md-5">
          <select class="form-select" [(ngModel)]="formData.package.pkg_code" name="package"
            (change)="doneModules=formData.package.pkg_code=='p4' ? 'open' : ''; updatePackagePrice();">
            <option value="">Select Package</option>
            <option value="p4" selected>Self Customized</option>
          </select>
        </div>
        <div class="col-md-4">
          <select class="form-select" [(ngModel)]="formData.package.bill_cycle" name="subscription"
            (change)="calculateExpiry(); updatePackagePrice();">
            <option>Monthly</option>
            <option>Quarterly</option>
            <option>Semi Annually</option>
            <option>Annually</option>
          </select>
        </div>
        <!-- <div class="col-md-2">
          <input type="number" class="form-control" placeholder="Users Limit" [(ngModel)]="formData.package.usersLimit"
            name="usersLimit">
        </div> -->
        <div class="col-md-3">
          <input type="number" class="form-control" placeholder="Std. Limit"
            [(ngModel)]="formData.package.std_counts" name="studentsLimit"
            (ngModelChange)="updatePackagePrice();">
        </div>
        <!-- <div class="col-md-4"><input
              type="date"
              class="form-control"
              [(ngModel)]="formData.package.startDate"
              name="startDate"
              (change)="calculateExpiry()"></div><div class="col-md-4"><input
              type="date"
              class="form-control"
              readonly
              [(ngModel)]="formData.package.expiryDate"
              name="expiryDate"></div> -->
        <div class="col-md-4">
          <input type="number" class="form-control" placeholder="Amount" 
            [(ngModel)]="formData.package.base_amount" name="amount" readonly>
        </div>
        <div class="col-md-8 d-flex justify-content-center align-items-center">
          <div class="btn-group btn-group-sm" role="group" aria-label="Basic radio toggle button group"
            (click)="updatePackagePrice(); doneModules='close';">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio1" [value]="true" 
              [(ngModel)]="formData.package.paid_offline" checked>
            <label class="btn btn-outline-secondary" for="btnradio1">I will pay Offline</label>

            <input type="radio" class="btn-check" name="btnradio" id="btnradio2" [value]="false" 
              [(ngModel)]="formData.package.paid_offline">
            <label class="btn btn-outline-secondary" for="btnradio2">I will pay Online</label>
          </div>

        </div>

        <!-- <div class="col-md-2">&nbsp;</div>
        <div class="col-md-6 form-group">
          <div class="coupon-input">
            <input type="text" class="form-control" [(ngModel)]="couponCode" (blur)="validateCoupon()"
              placeholder="Enter coupon code" />
            @if (couponValid) {
            <span class="coupon-valid">&#10003; Valid - {{ appliedCoupon?.discount_value }}{{ appliedCoupon?.discount_type
              === 'percentage' ? '%' : ' Rs.' }} off</span>
            } @else if (couponCode && couponValid === false) {
            <span class="coupon-invalid">&#10007; Invalid or expired coupon</span>
            }
          </div>
        </div> -->

      </div>

      <div class="form-card" *ngIf="formData.package.pkg_code=='p4' && doneModules=='open'">
        <h2>Select Your Plan</h2>
        <p class="section-desc">Choose modules and configure your subscription</p>

        <div class="modules-select mb-3">
          <div class="d-flex justify-content-between align-items-center px-3">
            <h4>Select Modules</h4>
            <div class="py-3 d-flex justify-content-center gap-3">
              <button class="btn btn-sm btn-light" (click)="doneModules='close';">Cancel</button>
              <button class="btn btn-sm btn-info" (click)="doneModules='close';updatePackagePrice();">Done!</button>
            </div>
          </div>
          <div class="modules-grid-large">
            @for (module of modules; track module.id) {
            <label class="module-card" [class.selected]="selectedModules.includes(module.code)">
              <input type="checkbox" [checked]="selectedModules.includes(module.code)"
                (change)="toggleModule(module.code)" />
              <div class="module-info">
                <strong class="module-title">{{ module.m_name }}</strong>
                <div class="module-desc">{{ module.description }}</div>
                <div class="module-prices">
                  <span>Monthly: Rs. {{ module.m_price }}/student</span>
                  <span>Quarterly: Rs. {{ module.q_price }}/student</span>
                  <span>Semi Annually: Rs. {{ module.h_price }}/student</span>
                  <span>Annually: Rs. {{ module.a_price }}/student</span>
                </div>
              </div>
            </label>
            }
          </div>
          <div class="py-3 d-flex justify-content-center gap-3">
            <button class="btn btn-sm btn-light" (click)="doneModules='close';">Cancel</button>
            <button class="btn btn-sm btn-info" (click)="doneModules='close';updatePackagePrice();">Done!</button>
          </div>
        </div>
      </div>

      <!-- <div class="form-group my-3" *ngIf="doneModules=='close'">
        <div class="py-3 d-flex justify-content-center">
          <button class="btn btn-sm btn-primary" (click)="showPreview=true;">Proceed!</button>
        </div>
      </div> -->

      <div class="row g-4 my-3" *ngIf="doneModules=='close'">
        <div class="form-card">
          <h2 align="center">Terms and Conditions</h2>
          <p align="center" class="section-desc">Please read and accept our terms and conditions</p>

          <div class="terms-content">
            <div class="terms-box">
              <h4>Service Agreement</h4>
              <p>By subscribing to Macwill ERP, you agree to the following terms:</p>
              <ul>
                <li>The subscription is valid for the selected billing cycle from the date of payment confirmation.</li>
                <li>The number of students is limited to the quantity selected during purchase.</li>
                <li>Data backup is provided according to your selected plan.</li>
                <li>The service can be renewed before expiry to ensure uninterrupted access.</li>
                <li>All prices are inclusive of applicable taxes.</li>
                <li>Macwill reserves the right to suspend services for non-payment or policy violations.</li>
                <li>Refunds are processed within 7-10 business days subject to approval.</li>
              </ul>
              <p>For complete terms, please refer to the Service Level Agreement document.</p>
            </div>
          </div>
          <div class="signature-section">
            <h5>Authorization Signature</h5>
            <div class="row">
              <div class="col-12 my-2">
                <label for="consent">
                  <input type="checkbox" id="consent" [(ngModel)]="formData.agreement.consent"
                  (change)="isTermsValid()">&nbsp;
                  Yes, I read and accept the terms and conditions.
                </label>
              </div>
              <div class="col-md-6">
                <label>Name <span class="required">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="formData.agreement.name" placeholder="Your full name"
                  (blur)="isTermsValid()" />
              </div>
              <div class="col-md-6">
                <label>Designation <span class="required">*</span></label>
                <select class="form-control" [(ngModel)]="formData.agreement.designation"
                  (change)="isTermsValid()">
                  <option value="">Select designation</option>
                  @for(d of dataService.designations; track $index) {
                    <option value="{{d.code}}">{{d.name}}</option>
                  }
                </select>
              </div>
            </div>
            <p class="legal-notice mt-3 mb-0 py-1 px-3 text-danger">
              <strong>Legal Notice:</strong> Your IP address, timestamp, and browser information will be recorded for legal purposes.
            </p>
          </div>
        </div>
      </div>

    </div>

    <div class="row g-4" *ngIf="currentStep===5">
        <div class="col-lg-6">

          <div class="card shadow-sm">
            <div class="card-header" style="padding: 5px 15px !important;">
              Organization Details
            </div>

            <div class="card-body">
              <p>
                <b>Name:</b>
                {{formData.organization.org_name}}
              </p>

              <!-- <p>
                <b>Reg./Affiliation:</b>
                {{formData.organization.reg_no}}
              </p> -->

              <p>
                <b>City:</b>
                {{formData.organization.org_city}}
              </p>

              <!-- <p>
                <b>Status:</b>
                {{formData.organization.status}}
              </p> -->

            </div>
          </div>

        </div>

        <div class="col-lg-6">
          <div class="card shadow-sm">
            <div class="card-header" style="padding: 5px 15px !important;">
              Institute Details
            </div>

            <div class="card-body">
              <p>
                <b>Name:</b>
                {{formData.institute.inst_name}}
              </p>

              <p>
                <b>Reg./Affilication:</b>
                {{formData.institute.reg_no}}
              </p>

              <p>
                <b>Phone No:</b>
                {{formData.institute.phone_no}}
              </p>

            </div>

          </div>

        </div>

        <!-- Pricing Summary -->
        <div class="pricing-summary col-lg-12">
          <div class="card shadow-sm">
            <div class="card-header" style="padding: 5px 15px !important;">
              Order Summary
            </div>

            <div class="card-body">
              <div class="summary-row">
                <span>Selected Modules: {{ selectedModules.length }}</span>
                <strong class="text-danger blink-text" 
                *ngIf="formData.package.pkg_code=='p4' && (!selectedModules || selectedModules.length==0)">
                  <-- No module selected.
                </strong>
              </div>
              <div class="summary-row">
                <span>Students: {{ formData.package.std_counts | number }}</span>
              </div>
              <div class="summary-row">
                <span>Billing Cycle: {{ formData.package.bill_cycle }}</span>
              </div>
              <div class="summary-divider"></div>
              <div class="summary-row">
                <span>Base Amount</span>
                <span>{{ formData.package.base_amount }}/-</span>
              </div>
              @if (formData.package.module_amount > 0) {
                <div class="summary-row discount">
                  <span>Modules Amount</span>
                  <span>+{{ formData.package.module_amount }}/-</span>
                </div>
              }
              <div class="summary-row">
                <span><b>Subtotal</b></span>
                <span><b>{{ formData.package.net_amount }}/-</b></span>
              </div>
              <div class="summary-row">
                <span>GST (18%)</span>
                <span>+{{ formData.package.tax_amount }}/-</span>
              </div>
              <div class="summary-divider"></div>
              <div class="summary-row total">
                <span>Total Amount (method {{formData.package.paid_offline ? 'Offline' : 'Online'}})</span>
                <span>{{ formData.package.total_amount }}/-</span>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div *ngIf="currentStep===6 && submitted">

      <div class="text-center py-5">

        <i class="bi bi-check-circle-fill text-success fs-1"></i>

        <h2>
          KYC Submitted Successfully
        </h2>

        <p class="mx-5">
          Our verification team will review your details.
          ERP login credentials will be shared after successful verification.
          If you were using Trial/Demo version, that login will not work now and you will receive a new login details.
        </p>

        <p align="center" *ngIf="formData.package.paid_offline">
          <button class="btn btn-sm btn-primary" (click)="dataService.auth.logout()" data-bs-dismiss="modal">Logout & Exit!</button>
        </p>
        <p align="center" *ngIf="!formData.package.paid_offline">
          <button class="btn btn-sm btn-primary" (click)="paymentClick()" data-bs-dismiss="modal">Proceed to Payment!</button>
        </p>

      </div>

    </div>
  </div>
  <div class="card-footer d-flex justify-content-between mt-2" *ngIf="!submitted && view=='client'">
    <span style="width: 90px;" *ngIf="currentStep == 0 || currentStep == 6">&nbsp;</span>
    <button *ngIf="currentStep > 0 && currentStep < 6" class="btn btn-secondary" (click)="previousStep()"> Previous
    </button>

    <div class="w-50" *ngIf="!submitted">
      <div class="d-flex justify-content-center mb-1 w-100">
        <!-- <span>KYC Completion</span> -->
        <span>{{getProgress()}}%</span>
      </div>
      <div class="progress w-100" style="height:10px;">
        <div class="progress-bar" role="progressbar" [style.width.%]="getProgress()">
        </div>
      </div>
    </div>
<!-- <button (click)="isStepCompletedX(currentStep+1)">Check!</button> -->
    <button *ngIf="currentStep < 5" type="button" class="btn btn-primary" (click)="nextStep()"
      [disabled]="currentStep==4 && (!isTermsValid() || doneModules=='open') || !isStepCompleted(currentStep+1)"> Next</button>
    <button *ngIf="currentStep==5" class="btn btn-success" (click)="submitKYC()"> Submit KYC </button>
  </div>
</div>
<!-- </div> -->